import { ref } from 'vue'
import { 
  doc,
  updateDoc, 
  arrayUnion, 
  arrayRemove,
  increment 
} from 'firebase/firestore'
import { db } from '@/services/firebase'

export function useBookmarks() {
  const loading = ref(false)
  const error = ref(null)

  // 북마크 추가
  const addBookmark = async (userId, jobId) => {
    loading.value = true
    error.value = null
    try {
      // 유저 문서에 북마크 추가
      const userRef = doc(db, 'users', userId)
      await updateDoc(userRef, {
        bookmarks: arrayUnion(jobId)
      })

      // 공고 문서에 북마크 카운트 증가
      const jobRef = doc(db, 'jobs', jobId)
      await updateDoc(jobRef, {
        bookmarkCount: increment(1)
      })

      return true
    } catch (e) {
      error.value = '북마크 추가에 실패했습니다.'
      console.error('북마크 추가 실패:', e)
      throw e
    } finally {
      loading.value = false
    }
  }

  // 북마크 제거
  const removeBookmark = async (userId, jobId) => {
    loading.value = true
    error.value = null
    try {
      // 유저 문서에서 북마크 제거
      const userRef = doc(db, 'users', userId)
      await updateDoc(userRef, {
        bookmarks: arrayRemove(jobId)
      })

      // 공고 문서에 북마크 카운트 감소
      const jobRef = doc(db, 'jobs', jobId)
      await updateDoc(jobRef, {
        bookmarkCount: increment(-1)
      })

      return true
    } catch (e) {
      error.value = '북마크 제거에 실패했습니다.'
      console.error('북마크 제거 실패:', e)
      throw e
    } finally {
      loading.value = false
    }
  }

  // 북마크 토글
  const toggleBookmark = async (userId, jobId, isBookmarked) => {
    if (isBookmarked) {
      return await removeBookmark(userId, jobId)
    } else {
      return await addBookmark(userId, jobId)
    }
  }

  // 북마크 여부 확인
  const isBookmarked = (userProfile, jobId) => {
    if (!userProfile || !userProfile.bookmarks) return false
    return userProfile.bookmarks.includes(jobId)
  }

  // 유저의 북마크 목록 가져오기
  const getBookmarks = (userProfile) => {
    if (!userProfile || !userProfile.bookmarks) return []
    return userProfile.bookmarks
  }

  return {
    loading,
    error,
    addBookmark,
    removeBookmark,
    toggleBookmark,
    isBookmarked,
    getBookmarks
  }
}